import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  padding: 20px;
  background-color: #222;
  color: white;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>© 2024 MuseMatch. All rights reserved.</FooterContainer>
  );
};

export default Footer;
